var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.5 0C6.71549 0 6.92215 0.0856026 7.07452 0.237976C7.2269 0.390349 7.3125 0.597012 7.3125 0.8125V5.6875H12.1875C12.403 5.6875 12.6097 5.7731 12.762 5.92548C12.9144 6.07785 13 6.28451 13 6.5C13 6.71549 12.9144 6.92215 12.762 7.07452C12.6097 7.2269 12.403 7.3125 12.1875 7.3125H7.3125V12.1875C7.3125 12.403 7.2269 12.6097 7.07452 12.762C6.92215 12.9144 6.71549 13 6.5 13C6.28451 13 6.07785 12.9144 5.92548 12.762C5.7731 12.6097 5.6875 12.403 5.6875 12.1875V7.3125H0.8125C0.597012 7.3125 0.390349 7.2269 0.237976 7.07452C0.0856026 6.92215 0 6.71549 0 6.5C0 6.28451 0.0856026 6.07785 0.237976 5.92548C0.390349 5.7731 0.597012 5.6875 0.8125 5.6875H5.6875V0.8125C5.6875 0.597012 5.7731 0.390349 5.92548 0.237976C6.07785 0.0856026 6.28451 0 6.5 0Z","fill":"#FED501"}));
}

Plus.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
